import { VariableType } from 'json-to-graphql-query';
import { EntityResource } from './entity.resource';
import { PointContainerVariables, PointContainerArgs } from './queryVariables/pointContainer';
/**
 * Resource kontenerów na punkty
 *
 * @export
 * @class PointContainerResource
 * @extends {EntityResource<PointContainer>}
 */
export class PointContainerResource extends EntityResource {
    constructor() {
        super({
            entityName: 'pointContainer',
            addMutationName: 'pointContainerAdd'
        });
        this.getFields = {
            id: true,
            name: true,
            partner: {
                id: true,
                name: true
            },
            containerBenefit: {
                id: true,
                points: true,
                maxUsagesPerUser: true,
                benefit: {
                    id: true,
                    name: true
                }
            }
        };
        this.listFields = {
            id: true,
            name: true
        };
        this.addVariables = PointContainerVariables;
        this.addArgs = PointContainerArgs;
        this.updateVariables = { id: 'Int!', name: 'String!' };
        this.updateArgs = { id: new VariableType('id'), name: new VariableType('name') };
        this.listVariables = { filters: 'FiltersWithPartnerId' };
    }
}
export const pointContainerResource = new PointContainerResource();
//# sourceMappingURL=pointContainer.resource.js.map